<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <!-- 悬浮球 -->
      <template v-if="$route.name === 'Suspension' && isElectron">
        <router-view />
      </template>
      <!-- 应用窗口 -->
      <template v-else-if="$route.name !== 'Suspension'">
        <MyTitle v-if="!isShowTitle" />
        <keep-alive :include="cachedViews">
          <router-view
            :class="['container', $route.name === 'Home' ? 'home' : '']"
            :style="{ fontSize: size + 'px' }"
          />
        </keep-alive>
        <import-resource ref="importResource" />
        <function-menu ref="functionMenu" v-move @openBindModal="openBindModal" />
        <bind-d-t-q-modal ref="BindDTQModalRef" />
        <GlobalTimer v-if="globalTimerVisible" ref="globalTimerRef" />
      </template>
    </div>
  </a-config-provider>
</template>
<script>
// import { token } from '@/utils/mockData'

import FunctionMenu from '@/components/common/FunctionMenu'
import BindDTQModal from './components/common/BindDTQModal.vue'
import ImportResource from '@/components/common/ImportResource.vue'
import { initDTQ, restartDTQ, setDTQBindTeacherData } from '@/utils/dtq'
import { isRunningInElectron } from '@/utils/electronUtils'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import GlobalTimer from '@/components/globalTimer/globalTimer.vue'

export default {
  name: 'App',
  components: {
    GlobalTimer,
    FunctionMenu,
    ImportResource,
    BindDTQModal
  },
  directives: {
    move: {
      // 指令绑定时：将 CSS right/bottom 转换为 left/top，避免拖动时坐标冲突
      bind(el, binding, vnode) {
        const that = vnode.context
        // 等 DOM 渲染完成后初始化位置
        vnode.context.$nextTick(() => {
          const { clientWidth, clientHeight } = document.documentElement
          const { offsetWidth, offsetHeight } = el
          // 将 right/bottom 固定值转成 left/top，保持视觉位置不变
          el.style.right = 'auto'
          el.style.bottom = 'auto'
          el.style.left = clientWidth - offsetWidth - 60 + 'px'
          el.style.top = clientHeight - offsetHeight - 60 + 'px'
        })

        // 使用 Pointer Events 统一处理鼠标和触屏，天然支持一体机触屏
        el.onpointerdown = function (e) {
          const { clientWidth, clientHeight } = document.documentElement
          const disX = e.clientX - el.offsetLeft
          const disY = e.clientY - el.offsetTop
          const startX = e.clientX
          const startY = e.clientY
          let captured = false

          el.onpointermove = function (ev) {
            // 移动距离超过 5px 才认为是真正拖动
            const dx = Math.abs(ev.clientX - startX)
            const dy = Math.abs(ev.clientY - startY)
            if (dx < 5 && dy < 5) return

            // 确认是拖动后才捕获指针
            if (!captured) {
              el.setPointerCapture(e.pointerId)
              captured = true
            }

            let left = ev.clientX - disX
            let top = ev.clientY - disY
            const { offsetWidth, offsetHeight } = el
            // 边界限制，不超出可视区域
            left = Math.max(0, Math.min(left, clientWidth - offsetWidth))
            top = Math.max(0, Math.min(top, clientHeight - offsetHeight))
            el.style.left = left + 'px'
            el.style.top = top + 'px'
            that.$refs.functionMenu.isMoving = true
            el.style.cursor = 'move'
          }

          el.onpointerup = function () {
            el.onpointermove = null
            el.onpointerup = null
            el.style.cursor = ''
            if (captured) {
              el.releasePointerCapture(e.pointerId)
            }
            // 延迟重置 isMoving，避免 pointerup 后立即触发 click 展开菜单
            setTimeout(() => {
              that.$refs.functionMenu.isMoving = false
            }, 50)
          }
        }
      }
    }
  },
  data() {
    return {
      zh_CN,
      isElectron: false,
      isShowTitle: false, // 是否隐藏标题
      globalTimerVisible: false
    }
  },
  computed: {
    size() {
      return Number(this.$store.getters.size)
    },
    cachedViews() {
      return this.$store.getters.cachedViews
    }
  },
  watch: {
    $route(to) {
      this.isShowTitle = to?.meta?.isShowTitle
    }
  },
  created() {
    this.isElectron = isRunningInElectron()
    if (this.isElectron) {
      initDTQ()
      window.electron.ipcRenderer.on('restart-dtq-exe', () => {
        restartDTQ()
      })
    }
    this.$store.commit('app/SET_IN_ELECTRON', this.isElectron)
    this.$bus.$on('dtqMessage', async data => {
      if (data.fun === 'card_update' && data.uID_t === 50) {
        await setDTQBindTeacherData(data)
        await initDTQ()
      }
    })
    this.$bus.$on('pointerMessage', data => {
      switch (data.ans_str) {
        case 'E':
          window.electron.ipcRenderer.send('window-show')
          break
        case 'F':
          window.electron.ipcRenderer.send('window-min')
          break
        case 'A':
        case 'B':
          if (data.key_event === 'double') {
            this.$router.back()
          }
          break
      }
    })
    this.$bus.$on('showGlobalTimer', minutes => {
      this.globalTimerVisible = true
      this.$nextTick(() => {
        this.$refs.globalTimerRef.time = minutes * 60
        this.$refs.globalTimerRef.totalTime = minutes * 60
      })
    })
    this.$bus.$on('hideGlobalTimer', () => {
      this.globalTimerVisible = false
    })
    this.$bus.$on('showGlobalTimerCustomModal', () => {
      this.globalTimerVisible = true
      this.$nextTick(() => {
        this.$refs.globalTimerRef.handleClickCustom()
      })
    })
  },
  methods: {
    openBindModal() {
      this.$refs.BindDTQModalRef.openModal()
    }
  }
}
</script>

<style lang="scss">
// 点名淡入淡出
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.8, -0.48, 1, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateZ(10px) translateY(30px);
  opacity: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid transparent;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  touch-action: none;
}

html,
body,
div {
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  // 头部40 底部64
  height: calc(100vh - 106px);
  position: relative;
  overflow: auto;
  &.home {
    // 头部40
    height: calc(100vh - 42px);
  }

  .footer {
    position: fixed;
    bottom: 1px;
    left: 1px;
    z-index: 99;
  }
}
// 滚动条整体粗细样式
::-webkit-scrollbar {
  // 高宽分别对应横竖滚动条的尺寸
  width: 16px;
  height: 16px;
}

// 滚动条里面滑块
::-webkit-scrollbar-thumb {
  border-radius: 8px !important;
  // 通过设置边框达到滑块在轨道中间的效果
  border: 3px solid #ffffff;
  /* 颜色 */
  background: #e5e5e5 !important;
}

// 滚动条轨道
::-webkit-scrollbar-track {
  background: transparent !important;
}
</style>
